export const ORDER = {
    ASC: 'asc',
    DESC: 'desc'
}

export const ORDER_TX = {
    [ORDER.ASC]: '升序',
    [ORDER.DESC]: '降序'
}

export const ORDER_TYPE = {
    BLOCK_NO: 'block_no',
    WATER_PRICE: 'water_price',
    SQUARE_PRICE: 'square_price',
    AREA: 'area'
}

export const ORDER_TYPE_TX = {
    [ORDER_TYPE.BLOCK_NO]: '楼栋数',
    [ORDER_TYPE.WATER_PRICE]: '总价',
    [ORDER_TYPE.SQUARE_PRICE]: '单价',
    [ORDER_TYPE.AREA]: '面积'
}
